import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { verifyPlatformSession } from '@/api/platformApi'
import { isPlatformAdmin, markPlatformSessionActive } from '@/utils/platformAdminAuth'
import { getPlatformLoginPath } from '@/config/platform'
import { setAuthNotice } from '@/utils/authFlow'

interface PlatformRouteProps {
  children: React.ReactNode
}

export function PlatformRoute({ children }: PlatformRouteProps) {
  const location = useLocation()
  const [checking, setChecking] = useState(true)
  const [valid, setValid] = useState(isPlatformAdmin())

  useEffect(() => {
    let cancelled = false
    verifyPlatformSession()
      .then(() => {
        if (!cancelled) {
          markPlatformSessionActive()
          setValid(true)
        }
      })
      .catch(() => {
        if (!cancelled) setValid(false)
      })
      .finally(() => {
        if (!cancelled) setChecking(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  if (checking) return null

  if (!valid) {
    setAuthNotice('platform', 'Sessão da plataforma inválida ou expirada. Faça login novamente.')
    return <Navigate to={getPlatformLoginPath()} state={{ from: location }} replace />
  }

  return <>{children}</>
}
